<template>
  <div class="apply-order">
    <div class="page box">
      <TiliteNav />
      <div class="mb40">
        <Tab v-model="tab" :list="tab_list" />
      </div>
      <div class="apply-toast">
        <img :src="$img('IconToast')" alt="">
        <span>*注意：请在报道日期进行报到，逾期后果自负</span>
      </div>
      <div class="block">
        <ApplyList :list="list" />
      </div>
      <div class="side-box">
        <div class="side-sticky">
          <SideNav />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ApplyList from '../../components/ApplyList'
  import SideNav from '../../components/SideNav'
  export default {
    data () {
      return {
        tab: 0,
        tab_list: [
          {
            name: '未报到',
            status: 0
          },
          {
            name: '已报到',
            status: 1
          }
        ],
        list: []
      }
    },
    watch: {
      tab () {
        this.GetList()
      }
    },
    activated () {
      this.GetList()
    },
    methods: {
      async GetList () {
        let { data, status } = await this.$Get('Course.orderList', {
          page: 1,
          limit: 200,
          shipping_status: this.tab_list[this.tab]['status']
        })
        if (status) {
          this.list = data.items
        }
      }
    },
    components: {
      SideNav,
      ApplyList
    }
  }
</script>

<style lang="less" scoped>
  .apply-order {
    min-width: 1200px;
    padding: 0 0 90px 0;
    .flex-ccc();
    .mb40 {
      margin-bottom: 40px;
    }
    .block {
      min-height: 658px;
      padding-bottom: 40px;
    }
    .apply-toast {
      width: 1200px;
      height: 62px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 10px;
      font-size: 16px;
      line-height: 21px;
      color: #FFAA00;
      box-sizing: border-box;
      padding-left: 40px;
      .flex-c();
      margin-bottom: 20px;
      img {
        width: 22px;
        height: 22px;
        margin-right: 12px;
      }
    }
    .box {
      padding-left: 170px;
      transform: translateX(-85px);
      position: relative;
    }
    .side-box {
      position: absolute;
      width: 140px;
      height: 100%;
      top: 0;
      left: 0;
      .side-sticky {
        position: sticky;
        top: 164px;
      }
    }
    /deep/ .cutomtab {
      .flex-cc();
    }
    /deep/ .tab-item {
      margin: 0 64px;
    }
  }
</style>
